module.exports = __webpack_public_path__ + "static/img/14000270.ce09559d.png";